"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getGatewayConfig: ()=>getGatewayConfig,
    oldDefaultGatewayConfig: ()=>oldDefaultGatewayConfig
});
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const domain_id_config_js_namespaceObject = require("../domain-id/domain-id.config.js");
const jwt_config_js_namespaceObject = require("../jwt/jwt.config.js");
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const query_config_js_namespaceObject = require("../utils/query.config.js");
const row_js_namespaceObject = require("../aegis-api-config/row.js");
const getOrigin = (domainID)=>`https://${domain_id_config_js_namespaceObject.domainIDHostnameMap[domainID]}`;
const oldDefaultGatewayConfig = {
    gatewayItems: {
        sandbox: {
            origin: getOrigin('sandbox'),
            jwtUniqueKey: 'sandbox',
            useJwt: false
        },
        boe: {
            origin: getOrigin('boe'),
            useJwt: false,
            jwtUniqueKey: 'boe'
        },
        online: {
            origin: getOrigin('online'),
            useJwt: false,
            jwtUniqueKey: 'online'
        },
        hl: {
            origin: getOrigin('hl'),
            useJwt: false,
            jwtUniqueKey: 'hl'
        },
        lq: {
            origin: getOrigin('lq'),
            useJwt: false,
            jwtUniqueKey: 'lq'
        },
        pd: {
            origin: getOrigin('pd'),
            useJwt: false,
            jwtUniqueKey: 'pd'
        },
        us: {
            origin: getOrigin('us'),
            useJwt: false,
            jwtUniqueKey: 'us'
        },
        i18n: {
            origin: getOrigin('i18n'),
            useJwt: false,
            jwtUniqueKey: 'i18n'
        },
        'i18n-sg': {
            origin: getOrigin('i18n-sg'),
            useJwt: false,
            jwtUniqueKey: 'i18n-sg'
        },
        'i18n-bd': {
            origin: getOrigin('i18n-bd'),
            useJwt: false,
            jwtUniqueKey: 'i18n-bd'
        },
        'i18n-bd-de': {
            origin: getOrigin('i18n-bd-de'),
            useJwt: false,
            jwtUniqueKey: 'i18n-bd-de'
        },
        'boe-i18n': {
            origin: row_js_namespaceObject.rowGatewayOriginConfig.boei18n,
            useJwt: true,
            jwtUniqueKey: 'online'
        },
        'ttp-us': {
            origin: getOrigin('ttp-us'),
            useJwt: false,
            jwtUniqueKey: 'ttp-us'
        },
        'ttp-us-limited': {
            origin: 'https://cloud.tiktok-us.net',
            useJwt: true,
            jwtUniqueKey: 'ttp-us-limited'
        },
        sinf: {
            origin: getOrigin('sinf'),
            useJwt: false,
            jwtUniqueKey: 'sinf'
        },
        sinfonlinea: {
            origin: getOrigin('sinfonlinea'),
            useJwt: false,
            jwtUniqueKey: 'sinfonlinea'
        },
        'sinf-boe': {
            origin: getOrigin('sinf-boe'),
            useJwt: true,
            jwtUniqueKey: 'sinf'
        },
        sinfi18n: {
            origin: getOrigin('sinfi18n'),
            useJwt: false,
            jwtUniqueKey: 'sinfi18n'
        },
        volcgroup: {
            origin: getOrigin('volcgroup'),
            useJwt: false,
            jwtUniqueKey: 'volcgroup'
        },
        'volcgroup-boe': {
            origin: getOrigin('volcgroup-boe'),
            useJwt: false,
            jwtUniqueKey: 'volcgroup-boe'
        },
        'ttp-row': {
            origin: getOrigin('ttp-row'),
            useJwt: false,
            jwtUniqueKey: 'ttp-row'
        },
        'ttp-row-sg': {
            origin: getOrigin('ttp-row-sg'),
            useJwt: false,
            jwtUniqueKey: 'ttp-row-sg'
        },
        currentOrigin: {
            origin: '',
            useJwt: false,
            jwtUniqueKey: 'currentOrigin'
        },
        'ttp-eu': {
            origin: 'https://bc-iedt-gw.tiktok-eu.net',
            useJwt: true,
            jwtUniqueKey: 'ttp-row'
        },
        'ttp-eu-de': {
            origin: 'https://bc-dedt-gw.tiktok-eu.net',
            useJwt: true,
            jwtUniqueKey: 'ttp-row-sg'
        }
    },
    jwtItems: {
        sandbox: jwt_config_js_namespaceObject.jwtItems.sandbox,
        online: jwt_config_js_namespaceObject.jwtItems.online,
        hl: jwt_config_js_namespaceObject.jwtItems.hl,
        lq: jwt_config_js_namespaceObject.jwtItems.lq,
        pd: jwt_config_js_namespaceObject.jwtItems.pd,
        boe: jwt_config_js_namespaceObject.jwtItems.boe,
        us: jwt_config_js_namespaceObject.jwtItems.us,
        i18n: jwt_config_js_namespaceObject.jwtItems.i18n,
        sinf: jwt_config_js_namespaceObject.jwtItems.sinf,
        'sinf-boe': jwt_config_js_namespaceObject.jwtItems["sinf-boe"],
        'ttp-us': jwt_config_js_namespaceObject.jwtItems["ttp-us"],
        'ttp-us-limited': jwt_config_js_namespaceObject.jwtItems["ttp-us-limited"],
        'i18n-sg': jwt_config_js_namespaceObject.jwtItems["i18n-sg"],
        sinfi18n: jwt_config_js_namespaceObject.jwtItems.sinfi18n,
        sinfonlinea: jwt_config_js_namespaceObject.jwtItems.sinfonlinea,
        volcgroup: jwt_config_js_namespaceObject.jwtItems.volcgroup,
        'volcgroup-boe': jwt_config_js_namespaceObject.jwtItems["volcgroup-boe"],
        'cn-byted': jwt_config_js_namespaceObject.jwtItems["cn-byted"],
        'local-test': jwt_config_js_namespaceObject.jwtItems["local-test"],
        'i18n-byteintl': jwt_config_js_namespaceObject.jwtItems["i18n-byteintl"],
        'ttp-row': jwt_config_js_namespaceObject.jwtItems["ttp-row"],
        'ttp-row-sg': jwt_config_js_namespaceObject.jwtItems["ttp-row-sg"],
        'cn-ttp-row': jwt_config_js_namespaceObject.jwtItems["cn-ttp-row"],
        'ttp-row-org': jwt_config_js_namespaceObject.jwtItems["ttp-row-org"],
        'sinf-bytedance': jwt_config_js_namespaceObject.jwtItems["sinf-bytedance"],
        'ttp-us-row': jwt_config_js_namespaceObject.jwtItems["ttp-us-row"],
        'i18n-bd': jwt_config_js_namespaceObject.jwtItems["i18n-bd"],
        'i18n-bd-de': jwt_config_js_namespaceObject.jwtItems["i18n-bd-de"],
        currentOrigin: {
            baseUrl: '/auth/api/v1',
            fetchTimeout: 8000
        }
    },
    domainIDToGatewayKey: {
        local: 'sandbox',
        boe: 'boe',
        sandbox: 'sandbox',
        online: 'online',
        hl: 'hl',
        lq: 'lq',
        pd: 'pd',
        us: 'us',
        i18n: 'i18n',
        'i18n-sg': 'i18n-sg',
        'boe-i18n': 'boe-i18n',
        'ttp-us': 'ttp-us',
        'ttp-us-limited': 'ttp-us-limited',
        sinf: 'sinf',
        'sinf-boe': 'sinf-boe',
        sinfi18n: 'sinfi18n',
        sinfonlinea: 'sinfonlinea',
        volcgroup: 'volcgroup',
        'volcgroup-boe': 'volcgroup-boe',
        tx: 'online',
        'tx-tt': 'online',
        xfl: 'online',
        'sinf-xfl': 'online',
        'sinf-xfl-boe': 'online',
        'ttp-row': 'ttp-row',
        'ttp-row-sg': 'ttp-row-sg',
        'ttp-eu': 'ttp-eu',
        'ttp-eu-de': 'ttp-eu-de',
        'i18n-bd': 'i18n-bd',
        'i18n-bd-de': 'i18n-bd-de'
    },
    gatewayKeyToDomainID: {
        boe: 'boe',
        sandbox: 'sandbox',
        online: 'online',
        hl: 'hl',
        lq: 'lq',
        pd: 'pd',
        us: 'us',
        i18n: 'i18n',
        'i18n-sg': 'i18n-sg',
        'boe-i18n': 'boe-i18n',
        'ttp-us': 'ttp-us',
        'ttp-us-limited': 'ttp-us-limited',
        sinf: 'sinf',
        'sinf-boe': 'sinf-boe',
        sinfi18n: 'sinfi18n',
        sinfonlinea: 'sinfonlinea',
        volcgroup: 'volcgroup',
        'volcgroup-boe': 'volcgroup-boe',
        'ttp-row': 'ttp-row',
        'ttp-row-sg': 'ttp-row-sg',
        'ttp-eu': 'ttp-eu',
        'ttp-eu-de': 'ttp-eu-de',
        'i18n-bd': 'i18n-bd',
        'i18n-bd-de': 'i18n-bd-de'
    }
};
const getGatewayConfig = once_default()(async ()=>{
    const tccProxy = new core_lib_namespaceObject.TccProxy({
        namespace: 'bytecloud.fe.config',
        key: 'gateway',
        isPreview: (0, query_config_js_namespaceObject.checkTccProxyFlag)('preview', 'gateway-config'),
        isTest: (0, query_config_js_namespaceObject.checkTccProxyFlag)('test', 'gateway-config'),
        defaultValue: oldDefaultGatewayConfig,
        hostname: 'undefined' != typeof location ? location.hostname : '',
        validator (value) {
            try {
                return Object.prototype.hasOwnProperty.call(value, 'gatewayItems');
            } catch (error) {
                return false;
            }
        },
        useFallbackHostname: true
    });
    return await tccProxy.getConfig() || oldDefaultGatewayConfig;
});
exports.getGatewayConfig = __webpack_exports__.getGatewayConfig;
exports.oldDefaultGatewayConfig = __webpack_exports__.oldDefaultGatewayConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getGatewayConfig",
    "oldDefaultGatewayConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
